import { Link } from "wouter";
import { FileQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

export default function NotFound() {
  return (
    <EmptyState
      icon={FileQuestion}
      title="Página não encontrada"
      description="O endereço que você abriu não existe no painel."
      action={
        <Button asChild>
          <Link href="/">Voltar ao painel</Link>
        </Button>
      }
    />
  );
}
